<template>
  <div class="navBar flex">
    <div class="cube flex" v-for="(item, index) in listBat" :key="index">
      <div class="circle_one">
        <img :src="item.pic" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum">
          <span class="num">{{ item.value }}</span>
          <span class="ys">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "@/api/index";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "带动农户",
          pic: require("images/index/nav/h_lndn.png"),
          value: 9915,
          unit: "户"
        },
        {
          name: "每户增收",
          pic: require("images/index/nav/cyzl/年产量.png"),
          value: 3200,
          unit: "元/年"
        },
        {
          name: "所在县农民人均可支配收入",
          pic: require("images/index/nav/schj/价格监测点.png"),
          value: 15000,
          unit: "元/年"
        },
        {
          name: "农民人均可支配收入",
          pic: require("images/index/nav/cyzl/年产值.png"),
          value: 26000,
          unit: "元/年"
        }
      ]
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData() {
      // 动态加载
      get("/api/restful/cyzl/headdata").then(res => {
        if (res.data) {
          let pic = "";
          this.listBat = res.data.map(e => {
            try {
              pic = require("images/index/nav/cyzl/" + e.name + ".png");
            } catch (e) {
              console.log(e);
              pic = require("images/index/nav/cyzl/年产量.png");
            }
            return {
              name: e.name,
              pic,
              value: e.value,
              unit: e.unit || ""
            };
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
  background url('~images/index/nav/navBg.png') center no-repeat
  background-size 100% 100%
  height 100%
  justify-content center
  width 23%
  opacity .9
  // cursor pointer

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem

  img
    width .25rem
    height .25rem
    vertical-align middle
</style>
